import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-setupsales',
  templateUrl: './setupsales.component.html',
  styleUrls: ['./setupsales.component.css']
})
export class SetupsalesComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  displayNext() {
    this.router.navigate(['/user']);
  }
}
